export const ENVIRONMENT_KEYS = {
  PRODUCTION: 'production',
  STAGING: 'staging',
  DEVELOPMENT: 'development',
};

export const ORGANIZATIONS_LOGO_URL =
  'https://storage.googleapis.com/headtotoe-dev-app-assets/logos/';

export const ORGANIZATIONS_HUB_LOGO_URL = ORGANIZATIONS_LOGO_URL + 'hub/';
